import { render, staticRenderFns } from "./MarketingCreateModalType.vue?vue&type=template&id=05b8fbc2&scoped=true"
import script from "./MarketingCreateModalType.vue?vue&type=script&lang=js"
export * from "./MarketingCreateModalType.vue?vue&type=script&lang=js"
import style0 from "./MarketingCreateModalType.vue?vue&type=style&index=0&id=05b8fbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8fbc2",
  null
  
)

export default component.exports